import React, { useEffect, useState } from "react";
import { exportTrialBalanceToExcel } from "./excelExportUtils";
import ExportExcelButton from "./ExportExcelButton";

function TrialBalanceOpeningGroup(props) {


    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

    const { datagetTrialBalanceReport, parentDetails, selected_mode_table_structure } = props
    const [expandedNodes, setExpandedNodes] = useState({});
    const [expandedGroups, setExpandedGroups] = useState({});

    useEffect(() => {
        if (datagetTrialBalanceReport && datagetTrialBalanceReport.length > 0) {
            const allExpandedNodes = Object.fromEntries(
                [...new Set(datagetTrialBalanceReport.map((d) => d.NODE))].map((node) => [node, true])
            );
            setExpandedNodes(allExpandedNodes);
        }
    }, [datagetTrialBalanceReport]);

    const handleExportExcel = () => {
        const selectedModeMeta = selected_mode_table_structure.find(
            (item) => item.mode_table_name === parentDetails.mode_list_array.find((m) => m.is_selected)?.mode_name
        );
        const visibleColumns = selectedModeMeta?.mode_table_columns.filter(
            (col) => col.column_key_from_api !== "NODE" && col.column_key_from_api !== "BALANCE"
        ) || [];

        exportTrialBalanceToExcel({
            data: datagetTrialBalanceReport,
            columns: visibleColumns,
            groupKeys: ["NODE"],
            valueKeys: ["DEBIT", "CREDIT"],
            deriveFromBalance: false,
            appendBalanceColumn: true,
            fileName: selectedModeMeta?.mode_table_name || "TrialBalanceOpeningGroup",
            sheetName: "Trial Balance",
        });
    };

    // Overall Debit / Credit / Balance totals, shown in the report footer
    const reportTotals = datagetTrialBalanceReport.reduce(
        (acc, r) => ({
            DEBIT: acc.DEBIT + (r.DEBIT || 0),
            CREDIT: acc.CREDIT + (r.CREDIT || 0),
        }),
        { DEBIT: 0, CREDIT: 0 }
    );
    const reportBalance = reportTotals.DEBIT - reportTotals.CREDIT;

    return (
        <div className="min-h-screen bg-gray-200 py-10 px-4">
            <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-none border border-gray-300 px-4 pt-4 pb-6 overflow-x-auto">



                <div>

                    <div>


                        {apiPaths_from_local_storage[0]?.REP_HEADER?.includes("data:image/") && (
                            <img
                                src={apiPaths_from_local_storage[0].REP_HEADER}
                            />
                        )}

                    </div>

                    <div style={{
                        fontSize: '18px',
                        fontWeight: '500',
                        color: '#0f172a',
                        textAlign: 'center',
                        textTransform: 'uppercase',
                        margin: '20px 0',
                        padding: '10px 16px',
                        backgroundColor: '#f8fafc',
                        borderRadius: '6px'
                    }}>
                        {
                            selected_mode_table_structure.find(
                                (item) => item.mode_table_code === parentDetails.mode_list_array.find((m) => m.is_selected)?.mode_code
                            )?.mode_table_name
                        }
                    </div>

                </div>

                {/* <ExportExcelButton onClick={handleExportExcel} /> */}

                <table className="min-w-full divide-y divide-gray-200 text-sm mt-3">
                    <thead className="border-b-2 border-gray-900">
                        <tr>
                            {selected_mode_table_structure
                                .filter((item) => item.mode_table_name === parentDetails.mode_list_array.filter((item) => item.is_selected)[0].mode_name)[0]
                                .mode_table_columns
                                .filter((col) => col.column_key_from_api !== "NODE" && col.column_key_from_api !== "BALANCE")
                                .map((item, i) => (
                                    <th
                                        key={i}
                                        className={`px-4 py-2 text-xs font-bold text-gray-900 uppercase tracking-wider ${["DEBIT", "CREDIT"].includes(item.column_key_from_api) ? "text-right" : "text-left"
                                            }`}
                                    >
                                        {item.column_name}
                                    </th>
                                ))}
                        </tr>
                    </thead>

                    <tbody className="divide-y divide-gray-100">
                        {(() => {

                            // Visible columns (no NODE, no BALANCE)
                            const visibleColumns = selected_mode_table_structure
                                .find((item) => item.mode_table_name === parentDetails.mode_list_array.find((m) => m.is_selected)?.mode_name)
                                ?.mode_table_columns.filter((col) => col.column_key_from_api !== "NODE" && col.column_key_from_api !== "BALANCE") || [];

                            // colSpan for label = index of DEBIT column
                            const debitIndex = visibleColumns.findIndex((col) => col.column_key_from_api === "DEBIT");
                            const labelColSpan = debitIndex > 0 ? debitIndex : 1;

                            // Helper: plain sum of the DEBIT and CREDIT columns
                            const calcTotal = (rowArr) => rowArr.reduce(
                                (acc, r) => ({
                                    DEBIT: acc.DEBIT + (r.DEBIT || 0),
                                    CREDIT: acc.CREDIT + (r.CREDIT || 0),
                                }),
                                { DEBIT: 0, CREDIT: 0 }
                            );

                            const grandTotal = calcTotal(datagetTrialBalanceReport);

                            return (
                                <>
                                    {Object.entries(
                                        datagetTrialBalanceReport.reduce((acc, row) => {
                                            if (!acc[row.NODE]) acc[row.NODE] = [];
                                            acc[row.NODE].push(row);
                                            return acc;
                                        }, {})
                                    ).map(([node, rows], nodeIndex) => {
                                        const nodeSubtotal = calcTotal(rows);

                                        return (
                                            <React.Fragment key={nodeIndex}>
                                                {/* NODE HEADER */}
                                                <tr
                                                    className="border-t border-gray-200 cursor-pointer hover:bg-gray-50"
                                                    onClick={() =>
                                                        setExpandedNodes((prev) => ({ ...prev, [node]: !prev[node] }))
                                                    }
                                                >
                                                    <td
                                                        colSpan={visibleColumns.length}
                                                        className="px-4 py-2 font-bold text-gray-900 text-sm flex items-center gap-2 uppercase tracking-wide"
                                                    >
                                                        <span className={`transition-transform ${expandedNodes[node] ? "rotate-90" : ""}`}>
                                                            ▶
                                                        </span>
                                                        {node}
                                                    </td>
                                                </tr>

                                                {/* ROWS UNDER NODE */}
                                                {expandedNodes[node] &&
                                                    rows.map((row, i) => (
                                                        <tr key={i} className="hover:bg-gray-50">
                                                            {visibleColumns.map((col, ci) => {
                                                                const key = col.column_key_from_api;
                                                                let displayValue = row[key];
                                                                if (key === "DEBIT" || key === "CREDIT") {
                                                                    const val = row[key] || 0;
                                                                    displayValue = val ? val.toFixed(2) : "";
                                                                }
                                                                return (
                                                                    <td
                                                                        key={ci}
                                                                        className={`px-4 py-2 text-sm ${["DEBIT", "CREDIT"].includes(key)
                                                                            ? "text-right tabular-nums font-mono"
                                                                            : "text-left text-gray-700"
                                                                            } ${key === "DEBIT" ? "text-blue-700"
                                                                                : key === "CREDIT" ? "text-emerald-700"
                                                                                    : ""
                                                                            }`}
                                                                    >
                                                                        {displayValue}
                                                                    </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    ))}

                                                {/* NODE SUBTOTAL */}
                                                {expandedNodes[node] && (
                                                    <tr className="border-t border-dashed border-gray-300 font-medium text-sm">
                                                        <td colSpan={labelColSpan} className="px-4 py-1.5 italic text-gray-500 text-xs">
                                                            Subtotal — {node}
                                                        </td>
                                                        <td className="px-4 py-1.5 text-right tabular-nums font-mono text-blue-700 text-xs">
                                                            {nodeSubtotal.DEBIT.toFixed(2)}
                                                        </td>
                                                        <td className="px-4 py-1.5 text-right tabular-nums font-mono text-emerald-700 text-xs">
                                                            {nodeSubtotal.CREDIT.toFixed(2)}
                                                        </td>
                                                    </tr>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}

                                    {/* GRAND TOTAL */}
                                    <tr className="font-bold text-sm" style={{ borderTop: "3px double #111827" }}>
                                        <td colSpan={labelColSpan} className="px-4 py-3 text-gray-900 uppercase tracking-wide text-xs">
                                            Grand Total
                                        </td>
                                        <td className="px-4 py-3 text-right tabular-nums font-mono text-blue-800">{grandTotal.DEBIT.toFixed(2)}</td>
                                        <td className="px-4 py-3 text-right tabular-nums font-mono text-emerald-800">{grandTotal.CREDIT.toFixed(2)}</td>
                                    </tr>
                                </>
                            );
                        })()}
                    </tbody>
                </table>

                {/* ── Report Footer ── */}
                <div className="mt-8">
                    <div className="border-t-2 border-gray-900" />
                    <div className="mt-0.5 border-t border-gray-300" />
                    <div className="mt-4 flex justify-between items-center">

                        <p className="text-xs text-gray-400">
                            Generated: {new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
                        </p>
                        <p className="text-xs font-semibold text-gray-700">
                            Balance: <span className="font-mono tabular-nums">{reportBalance.toFixed(2)}</span>
                        </p>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default TrialBalanceOpeningGroup